export default __webpack_public_path__ + "static/media/Gallery3.37c57ece.jpg";